var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "mlset-conditions",
    },
    [
      _c(
        "div",
        { staticClass: "mlconditions-list-box" },
        _vm._l(_vm.conditionConf.items, function (item, inx) {
          return _c(
            "el-row",
            {
              key: inx,
              staticClass: "mb-10 mlconditions-list",
              attrs: { gutter: 10 },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "div",
                    { staticClass: "field-one" },
                    [
                      _c("span", { staticClass: "field-inx" }, [
                        _vm._v(_vm._s(inx + 1)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-icon",
                        {
                          staticClass: "remove-icon",
                          attrs: { size: "18" },
                          on: {
                            click: function ($event) {
                              return _vm.delConditions(inx)
                            },
                          },
                        },
                        [_c("ElIconRemoveFilled")],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "field-select",
                      attrs: {
                        filterable: "",
                        "no-match-text": "无匹配文本",
                        size: "default",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.fieldChange(item)
                        },
                      },
                      model: {
                        value: item.fieldName,
                        callback: function ($$v) {
                          _vm.$set(item, "fieldName", $$v)
                        },
                        expression: "item.fieldName",
                      },
                    },
                    _vm._l(_vm.fieldList, function (op) {
                      return _c("el-option", {
                        key: op.fieldName,
                        attrs: { label: op.label, value: op.fieldName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "default" },
                      on: {
                        change: function ($event) {
                          return _vm.getOpCom(item)
                        },
                      },
                      model: {
                        value: item.op,
                        callback: function ($$v) {
                          _vm.$set(item, "op", $$v)
                        },
                        expression: "item.op",
                      },
                    },
                    _vm._l(_vm.getSelectOp(item), function (op) {
                      return _c("el-option", {
                        key: op,
                        attrs: { label: _vm.op_type[op], value: op },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 10 } }, [
                item.opCom == "datePicker"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          class: { "is-error": item.isError },
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "default",
                            type: "date",
                            format: "YYYY/MM/DD",
                            "value-format": "YYYY-MM-DD",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                      ],
                      1
                    )
                  : item.opCom == "datePickerBw"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          staticClass: "bw-start-icon mb-5",
                          class: { "is-error": item.isError && !item.value },
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "default",
                            type: "date",
                            format: "YYYY/MM/DD",
                            "value-format": "YYYY-MM-DD",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.bwChange(item)
                            },
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticClass: "bw-end-icon",
                          class: { "is-error": item.isError && !item.value2 },
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "default",
                            type: "date",
                            format: "YYYY/MM/DD",
                            "value-format": "YYYY-MM-DD",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.bwChange(item)
                            },
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                          },
                          model: {
                            value: item.value2,
                            callback: function ($$v) {
                              _vm.$set(item, "value2", $$v)
                            },
                            expression: "item.value2",
                          },
                        }),
                      ],
                      1
                    )
                  : item.opCom == "numberInput"
                  ? _c(
                      "div",
                      [
                        _c("el-input-number", {
                          staticClass: "mlnumer-input w-100",
                          class: { "is-error": item.isError },
                          attrs: { size: "default", controls: false },
                          on: {
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                      ],
                      1
                    )
                  : item.opCom == "numberInputBw"
                  ? _c(
                      "div",
                      [
                        _c("el-input-number", {
                          staticClass: "mlnumer-input w-100 bw-start-icon mb-5",
                          class: { "is-error": item.isError && !item.value },
                          attrs: { size: "default", controls: false },
                          on: {
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                            change: function ($event) {
                              return _vm.bwChange(item)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input-number", {
                          staticClass: "mlnumer-input w-100 bw-end-icon",
                          class: { "is-error": item.isError && !item.value2 },
                          attrs: { size: "default", controls: false },
                          on: {
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                            change: function ($event) {
                              return _vm.bwChange(item)
                            },
                          },
                          model: {
                            value: item.value2,
                            callback: function ($$v) {
                              _vm.$set(item, "value2", $$v)
                            },
                            expression: "item.value2",
                          },
                        }),
                      ],
                      1
                    )
                  : item.opCom == "textInput"
                  ? _c(
                      "div",
                      [
                        _c("el-input", {
                          class: { "is-error": item.isError },
                          attrs: { size: "default" },
                          on: {
                            focus: function ($event) {
                              return _vm.clearError(item)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                      ],
                      1
                    )
                  : item.opCom == "booleanSelect"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            class: { "is-error": item.isError },
                            attrs: { size: "default", placeholder: " " },
                            on: {
                              focus: function ($event) {
                                return _vm.clearError(item)
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "0" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : item.opCom == "userSelect"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            class: { "is-error": item.isError },
                            attrs: {
                              size: "default",
                              placeholder: " ",
                              filterable: "",
                              "no-match-text": "无匹配文本",
                            },
                            on: {
                              focus: function ($event) {
                                return _vm.clearError(item)
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          },
                          _vm._l(_vm.userList, function (userOp, userInx) {
                            return _c("el-option", {
                              key: userInx,
                              attrs: {
                                label: userOp.userName,
                                value: userOp.userId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : item.opCom == "departmentSelect"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            class: { "is-error": item.isError },
                            attrs: {
                              size: "default",
                              placeholder: " ",
                              filterable: "",
                              "no-match-text": "无匹配文本",
                            },
                            on: {
                              focus: function ($event) {
                                return _vm.clearError(item)
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          },
                          _vm._l(
                            _vm.departmentList,
                            function (departmentOp, departmentInx) {
                              return _c("el-option", {
                                key: departmentInx,
                                attrs: {
                                  label: departmentOp.departmentName,
                                  value: departmentOp.departmentId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : item.opCom == "optionData"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            class: { "is-error": item.isError },
                            attrs: { size: "default", placeholder: " " },
                            on: {
                              focus: function ($event) {
                                return _vm.clearError(item)
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          },
                          _vm._l(item.optionData, function (userOp, userInx) {
                            return _c("el-option", {
                              key: userInx,
                              attrs: {
                                label: userOp.label || userOp.value,
                                value: userOp.value,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : item.opCom == "referenceSearch"
                  ? _c(
                      "div",
                      [
                        _c("el-input", {
                          class: { "is-error": item.isError },
                          attrs: { readonly: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        on: { click: _vm.openReferenceDialog },
                                      },
                                      [_c("el-icon", [_c("ElIconSearch")], 1)],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.value2,
                            callback: function ($$v) {
                              _vm.$set(item, "value2", $$v)
                            },
                            expression: "item.value2",
                          },
                        }),
                        _vm._v(" "),
                        _vm.formatEntityName
                          ? _c(
                              "el-dialog",
                              {
                                staticClass: "reference-dialog",
                                attrs: {
                                  title: "请选择",
                                  "append-to-body": "",
                                  width: "520",
                                },
                                model: {
                                  value: _vm.showReferenceDialogFlag,
                                  callback: function ($$v) {
                                    _vm.showReferenceDialogFlag = $$v
                                  },
                                  expression: "showReferenceDialogFlag",
                                },
                              },
                              [
                                _c("ReferenceSearchTable", {
                                  attrs: {
                                    entity: _vm.formatEntityName,
                                    refField: item.fieldName,
                                  },
                                  on: {
                                    recordSelected: function (event) {
                                      return _vm.setReferRecord(event, item)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mladd-conditions" }, [
        _c(
          "span",
          { staticClass: "ml-a-span", on: { click: _vm.addConditions } },
          [
            _c(
              "el-icon",
              { staticClass: "add-icon", attrs: { size: "18" } },
              [_c("ElIconCirclePlusFilled")],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "ml-8" }, [_vm._v("添加条件")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mlconditions-mode mt-10" },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "default" },
              on: { change: _vm.conditionTypeChange },
              model: {
                value: _vm.conditionConf.type,
                callback: function ($$v) {
                  _vm.$set(_vm.conditionConf, "type", $$v)
                },
                expression: "conditionConf.type",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("符合任一")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("符合全部")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 3 } }, [_vm._v("高级表达式")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.conditionConf.type == 3
            ? _c("el-input", {
                staticClass: "mt-5",
                class: { "is-error": _vm.errorEquation },
                attrs: {
                  clearable: "",
                  placeholder: _vm.getPlaceholder(),
                  size: "default",
                },
                model: {
                  value: _vm.conditionConf.equation,
                  callback: function ($$v) {
                    _vm.$set(_vm.conditionConf, "equation", $$v)
                  },
                  expression: "conditionConf.equation",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.footer
        ? _c(
            "div",
            { staticClass: "mlconditions-footer mt-10" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "default" },
                  on: { click: _vm.confirm },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "default" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }